<p-drawer
  [(visible)]="displayChat"
  position="right"
  appendTo="body"
  (onHide)="onHide()"
  [style]="{ width: '370px' }"
  [style]="{ padding: '0' }">
  <ng-template #header>
    <h2 class="p-2">Chat Box - {{ moduleName }} # {{ moduleId }}</h2>
  </ng-template>
  <div class="mb-2 clientdetails">
    <div class="msg-box">
      <div>
        <div *ngFor="let chat of messageList; let i = index">
          <div class="d-flex justify-content-center align-items-center">
            <h4 class="client-badge" *ngIf="isTodayVisible(i)">Today</h4>
          </div>
          <div
            class="position-relative mb-4 col-lg-12"
            *ngIf="!chat.isLoginUser">
            <div
              class="rounded-circle position-absolute gray-msg top-0 start-0 translate-middle usercir-name d-flex justify-content-center align-items-center">
              {{ chat.createdBy | nameInitials }}
            </div>
            <p
              class="m-0 gray-msg p-2 rounded"
              [innerHtml]="formatMessage(chat.message)"></p>
            <span
              class="col-lg-12 chat-timedate d-flex justify-content-start gap-3">
              <span class="chat-time">{{
                chat.createdDate | date: "h:mm a"
              }}</span>
              <span class="chat-date" *ngIf="isDateVisible(chat.createdDate)">{{
                chat.createdDate | date: "MMMM d,yyyy"
              }}</span>
            </span>
          </div>

          <div class="d-flex justify-content-end" *ngIf="chat.isLoginUser">
            <div class="position-relative mb-4 col-lg-12">
              <p
                class="m-0 blue-msg p-2 rounded"
                [innerHtml]="formatMessage(chat.message)"></p>
              <span
                class="col-lg-12 chat-timedate d-flex justify-content-end gap-3">
                <span class="chat-time">{{
                  chat.createdDate | date: "h:mm a"
                }}</span>
                <span
                  class="chat-date"
                  *ngIf="isDateVisible(chat.createdDate)"
                  >{{ chat.createdDate | date: "MMMM d,yyyy" }}</span
                >
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="position-absolute bottom-0 chatarea-wdth">
      <p-select
        #tagDropdown
        [(ngModel)]="selectedTagId"
        class="mb-2"
        (onChange)="onTagSelectionChange(selectedTagId)"
        *ngIf="showTagDropdown"
        notFoundText="No User Found"
        [options]="users"
        optionLabel="name"
        optionValue="userId"
        [filter]="true"
        [showClear]="true">
      </p-select>
      <div class="col-lg-12">
        <textarea
          rows="3"
          pInputText
          [disabled]="isTextAreaDisabled"
          placeholder="Type your message"
          (keydown)="inputHandler($event)"
          [(ngModel)]="newMessage"
          cols="30"
          pInputTextarea
          class="w-full w-100"></textarea>
      </div>

      <div class="col-lg-12">
        <p-button label="Send" (click)="sendMessage()"></p-button>
      </div>
    </div>
  </div>
</p-drawer>
